'use client'
import { Slider, type SliderProps } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

export interface LevelsSliderProps extends SliderProps {
  level: number
}

export function LevelsSlider({ level, ...props }: LevelsSliderProps) {
  const rangeClassName = [
    'bg-bronze-gradient',
    'bg-silver-gradient',
    'bg-gold-gradient',
    'bg-diamond-gradient',
    'bg-advisor-gradient',
  ]
  const thumbClassName = [
    'border-bronze ring-bronze bg-bronze',
    'border-silver ring-silver bg-silver',
    'border-gold ring-gold bg-gold',
    'border-diamond ring-diamond bg-diamond',
    'border-advisor ring-advisor bg-advisor',
  ]

  return (
    <Slider
      color='custom'
      rangeClassName={cn(rangeClassName[level - 1], 'rounded-full')}
      thumbClassName={cn(thumbClassName[level - 1])}
      noThumb
      {...props}
    />
  )
}
